import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import "../Css/HomePage.css";
import HomeAbout from '../Component/Home/HomeAbout';
import HomeCategory from '../Component/Home/HomeCategory';
import HomeAboutProgress from '../Component/Home/HomeAboutProgress';
import HomeTrending from '../Component/Home/HomeTrending';
import Footer from '../Component/Footer/Footer';
import HomeOffer from '../Component/Home/HomeOffer';
import HomeReview from '../Component/Home/HomeReview';

import banner1 from "../Images/banner/banner01.jpg";
import banner2 from "../Images/banner/banner02.jpg";
import banner3 from "../Images/banner/banner03.png";
import AppCategory from '../Component/AppComponent/HomeSection/AppCategory';
import OfferPage from '../Component/AppComponent/HomeSection/OfferPage';
import AppSigCategory from '../Component/AppComponent/HomeSection/AppSigCategory';
import AppHomeBooking from '../Component/AppComponent/HomeSection/AppHomeBooking';
import FooterNav from '../Component/AppComponent/Footer/FooterNav';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import HomeBrand from '../Component/Home/HomeBrand';



const Home = () => {
    const images = [banner1, banner2, banner3];
    const [currentIndex, setCurrentIndex] = useState(0);

    // Auto-change banner every 5 seconds
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <div>
            {/* <section className="home-section-banner-wrapper"> */}
                {/* {images.map((image, index) => (
                    <div
                        key={image}
                        className={`home-section-banner-slide ${index === currentIndex ? 'active' : ''}`}
                        style={{
                            backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2)), url(${image})`,
                        }}
                    ></div>
                ))} */}
                {/* 
                <div className="home-section-banner-main-con">
                    <div className="home-section-banner-con">
                        <TypewriterEffect text="Woodsy Makes Spaces Look Better" speed={100} />
                        <p>Upgrade your home with our beautiful and eco-friendly wooden products.</p>
                        <div className="home-section-banner-btn">
                            <Link to="/product">
                            <button>View Product</button>
                            </Link>
                        </div>
                    </div>
                </div> */}

                {/* <div className='home-section-banner-swiper-con'>
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={true}
                        modules={[Autoplay, Pagination, Navigation]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <div className='home-bnner-section-image-main-con'>
                                <img src={banner1} />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='home-bnner-section-image-main-con'>
                                <img src={banner2} />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className='home-bnner-section-image-main-con'>
                                <img src={banner3} />
                            </div>
                        </SwiperSlide>
                    </Swiper>

                </div> */}
            {/* </section> */}
            <AppCategory />
            <OfferPage />
            <AppHomeBooking />
            {/* <HomeBrand /> */}

            {/* <AppSigCategory /> */}
            <HomeAbout />
            <HomeTrending />
            <HomeCategory />
            <HomeBrand />
            <HomeAboutProgress />
            {/* <HomeOffer /> */}
            <HomeReview />
            <Footer />
            <FooterNav />
        </div>
    );
};

export default Home;